export default __webpack_public_path__ + "static/media/SPG-BNB.542e2787.svg";